import { useCallback } from 'react'
import type { GridApi, GridReadyEvent } from 'ag-grid-community'

// v4 — добавлена колонка «Заметка» (для всех ролей), инвалидирует старый localStorage
// v5 (16.07.2026): добавлена колонка «Контакт» (Контроль КП) — bump версии,
// чтобы сохранённое состояние v4 не прятало новую колонку.
const COL_STATE_KEY = (userId: string) => `crm_requests_cols_v5_${userId}`
// Модель фильтров-воронок (в т.ч. «Менеджер») — отдельно от раскладки колонок,
// чтобы фильтр не слетал при уходе в карточку заявки и возврате назад.
const FILTER_STATE_KEY = (userId: string) => `crm_requests_filter_v1_${userId}`

/** Per-user сохранение вида таблицы заявок: раскладка колонок + воронки-фильтры. */
export function useRequestsColumnPersist(userId: string | undefined) {
  const saveState = useCallback(
    (api: GridApi) => {
      if (!userId) return
      try {
        localStorage.setItem(COL_STATE_KEY(userId), JSON.stringify(api.getColumnState()))
        localStorage.setItem(FILTER_STATE_KEY(userId), JSON.stringify(api.getFilterModel()))
      } catch {
        /* ignore */
      }
    },
    [userId],
  )

  const onGridReady = useCallback(
    (params: GridReadyEvent) => {
      if (!userId) return
      const saved = localStorage.getItem(COL_STATE_KEY(userId))
      if (saved) {
        try {
          params.api.applyColumnState({ state: JSON.parse(saved), applyOrder: true })
        } catch {
          /* ignore */
        }
      }
      // Восстанавливаем воронки-фильтры (в т.ч. «Менеджер»), чтобы они переживали
      // переход в карточку заявки и обратно.
      const savedFilter = localStorage.getItem(FILTER_STATE_KEY(userId))
      if (savedFilter) {
        try {
          params.api.setFilterModel(JSON.parse(savedFilter))
        } catch {
          /* ignore */
        }
      }
    },
    [userId],
  )

  return { saveState, onGridReady }
}
